import type { DriveStep, PopoverDOM } from 'driver.js';

/** 报告分享与导出说明弹层使用的统一 Driver 样式类。 */
export const REPORT_ACTION_GUIDE_POPOVER_CLASS = 'onboarding-report-action-guide-popover';

/** 移除 Driver 默认操作区，仅保留解释引导出现原因的文案。 */
function removePopoverControls(popover: PopoverDOM): void {
    popover.closeButton.remove();
    popover.footer.remove();
}

/**
 * 创建报告操作引导的主目标步骤。
 * @param element 需要浮出遮罩的导出或下载按钮。
 * @param description 当前语言下的分享与导出说明。
 * @returns 仅包含说明文案、无操作按钮的 Driver 步骤。
 */
export function createReportActionGuideStep(element: Element, description: string): DriveStep {
    return {
        element,
        disableActiveInteraction: false,
        popover: {
            description,
            side: 'bottom',
            align: 'end',
            showButtons: ['close'],
            popoverClass: REPORT_ACTION_GUIDE_POPOVER_CLASS,
            onPopoverRender: removePopoverControls,
        },
    };
}
